// Mobile edge pull-tabs that open the Channels / People drawers.
type MobileDrawerTabsProps = {
  tabBgClass: string;
  showDrawerTabs: boolean;
  showPeople: boolean;
  onOpenChannels: () => void;
  onOpenPeople: () => void;
};

// With the setting off the tabs are invisible to touch (swipe still opens the drawers), but a mouse has no swipe,
// so keep them faintly visible there and bright on hover. Otherwise a narrow desktop window has no visible way in.
const tabIdleClass = 'opacity-0 [@media(pointer:fine)]:opacity-40 hover:opacity-100';

function MobileDrawerTabs({
  tabBgClass,
  showDrawerTabs,
  showPeople,
  onOpenChannels,
  onOpenPeople,
}: MobileDrawerTabsProps) {
  return (
    <div className="md:hidden fixed inset-y-0 left-0 right-0 z-30 pointer-events-none">
      <div className="absolute left-0 top-1/2 -translate-y-1/2">
        <button
          className={`pointer-events-auto flex items-center justify-center rounded-r-xl ${tabBgClass} shadow-lg shadow-black/40 transition-opacity active:opacity-70 ${showDrawerTabs ? 'opacity-100' : tabIdleClass}`}
          style={{ width: 22, height: 80 }}
          aria-label="Open channels"
          onClick={onOpenChannels}
        >
          <span className="text-white font-medium tracking-wide select-none" style={{ fontSize: '0.625rem', writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>
            Channels
          </span>
        </button>
      </div>
      {showPeople && (
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <button
            className={`pointer-events-auto flex items-center justify-center rounded-l-xl ${tabBgClass} shadow-lg shadow-black/40 transition-opacity active:opacity-70 ${showDrawerTabs ? 'opacity-100' : tabIdleClass}`}
            style={{ width: 22, height: 80 }}
            aria-label="Open members"
            onClick={onOpenPeople}
          >
            <span className="text-white font-medium tracking-wide select-none" style={{ fontSize: '0.625rem', writingMode: 'vertical-rl' }}>
              Members
            </span>
          </button>
        </div>
      )}
    </div>
  );
}

export default MobileDrawerTabs;
